export const config = {
  cognito: {
    // PROD: Using CMS Roster PROD Cognito pool for authentication
    userPoolId: 'us-east-1_xkH9xTlrR',
    clientId: '1jkslto7ab1tqftaiq3j4m8ra4', // CMS Roster PROD client ID (lms_roster_client)
    region: 'us-east-1'
  },
  api: {
    // Use /api prefix - nginx will proxy to backend ALB (keeping /api/ for ALB routing)
    baseUrl: process.env.REACT_APP_API_URL || '/api'
  }
};

